module.exports = __webpack_public_path__ + "media/images/fb-0bb22e9a.svg";